module.exports = __webpack_public_path__ + "static/lawn-fbeab711941de0d5667a4ccb17403a87.jpg";